import { render, staticRenderFns } from "./producto.vue?vue&type=template&id=ee654028&scoped=true"
import script from "./producto.vue?vue&type=script&lang=js"
export * from "./producto.vue?vue&type=script&lang=js"
import style0 from "./producto.vue?vue&type=style&index=0&id=ee654028&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee654028",
  null
  
)

export default component.exports